import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tag } from '../Tag/Tag.js';
export const TagInput = forwardRef(({ onClick, children }, ref) => {
    return (_jsx("div", { className: "control", children: _jsx("div", { ref: ref, className: "field input is-clickable", style: { height: 'auto', minHeight: '2.5em' }, onClick: onClick, children: _jsx(Tag.Group, { children: children }) }) }));
});
TagInput.displayName = 'TagInput';
//# sourceMappingURL=TagInput.js.map